module.exports = __webpack_public_path__ + "static/dead.b559c949.png";


//////////////////
// WEBPACK FOOTER
// ./src/examples/vampire-example/dead.png
// module id = 1013
// module chunks = 13396140415750